import styled, { css } from "styled-components/macro";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  background: #f7f7f7f7;
`;

export const MenuBox = styled.div`
  position: relative;
  background-color: #fff;
  padding-bottom: 20px;
`;

export const MenuTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logostring {
    color: #73972c;
    font-size: 44px;
    width: 40%;
    padding: 0px 0px 0px 20px;

    font-family: "Poppins", sans-serif;
    letter-spacing: -2px;

     /* 반응형 폰트 크기 조정 */
    @media screen and (max-width: 1024px) {
      font-size: 36px;
    }
  }

  .logospan {
    color: #778682;
    font-family: "Poppins", sans-serif;
  }
  .main-logo {
    width: 70%;
    padding: 20px 0px 0px 20px;

    & img {
      width: 40%;
      cursor: pointer;
    }
  }
  .main-icon {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    & img {
      margin-right: 24px;
      cursor: pointer;
    }
  }
  @media screen and (max-width: 1024px) {
    .main-logo {
      width: 70%;
      padding: 20px 0px 0px 20px;

      & img {
        width: 25%;
        cursor: pointer;
      }
    }
  }
`;

export const MenuBot = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  .menu-item {
    width: 15%;
    margin: 0px 30px;
    text-align: center;

    & img {
      width: 100%;
      cursor: pointer;
    }

    & p {
      font-weight: 700;
      font-size: 1.1em;
      margin-top: 10px;
    }
  }

  @media screen and (max-width: 1024px) {
    .menu-item {
      width: 12%;
    & p {
      font-weight: 700;
      // font-size: 1.1em;
      font-size: 12px;
      margin-top: 10px;
    }
    }
     
  }
`;

export const DiaryBox = styled.div`
  width: 100%;
  background-color: #f7f7f7f7;
`;
export const DiaryNoList = styled.div`
  text-align: center;
  padding-top: 100px;

  & p {
    & img {
      width: 1%;
      position: relative;
      top: 1px;
      left: -3px;
    }
  }
  & p:first-child {
    font-size: 2em;
    font-weight: 500;
  }

  & p:last-child {
    font-size: 1.1em;
    color: #979797;
    margin-top: 10px;
  }
`;

export const DiarySelectBox = styled.div``;

export const DiarySelectArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 26px 20px 40px;
  background-color: #dddddd;

  p {
    font-size: 1.1em;
    font-weight: 700;

    &.diary-select-arrow-btn {
      cursor: pointer;
      transform: rotate(0deg);
      transition-duration: 1s;
    }

    &.diary-select-arrow-btn-rotate {
      transform: rotate(180deg);
      transition-duration: 1s;
    }
  }
`;

export const DiarySelect = styled.div`
  /* overflow: hidden; */
  transition-duration: 1s;
  &.show {
    overflow: hidden;
    max-height: 300px;
    transition-duration: 1s;
  }
  &.hide {
    overflow: hidden;
    max-height: 0px;
    transition-duration: 1s;
  }
`;

export const DiarySelectOn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0px 30px;
  /* overflow: hidden; */
  transform: translateY(0px);
  transition-duration: 1s;
  background-color: #dddddd;

  .diary-select-item {
    width: 49%;
    margin-top: 5px;
    & p {
      font-size: 1em;
      font-weight: 400;
      color: #656565;
    }

    & select {
      width: 100%;
      height: 38px;
      margin-top: 5px;
      padding: 10px 8px;
      font-size: 0.88em;
    }

    & input {
      width: 48%;
      height: 38px;
      margin-top: 5px;
      padding: 10px 8px;
      font-size: 0.88em;
    }

    .diary-date-box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      & p {
        width: 4%;
      }
    }
  }

  .diary-select-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0px;

    & div {
      margin-left: 20px;
    }
    & .diary-select-Initialization {
      color: #656565;
      font-size: 1em;
      font-weight: 500;
      background-color: #fff;
      padding: 10px 26px 10px 27px;
      border-radius: 5px;

      & img {
        margin-right: 5px;
      }
    }

    & .diary-select-submit {
      padding: 10px 72px;
      background-color: #73972c;
      color: #fff;
      font-size: 1em;
      font-weight: 500;
      border-radius: 5px;
    }
  }
`;

export const DiaryItem = styled.div``;
